<template>
  <div>
    <vxe-grid
      ref="table"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 8"
      size="small"
      :seq-config="{
        startIndex: 0,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <ExpandSampleTable :tableData="row.transferBoxDetailList" />
      </template>
      <template v-slot:status="{ row }">
        <el-tag size="mini" :type="row.orgStatus === 'Y' ? 'light' : 'warning'">
          {{ row.v_orgStatus }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
      <template v-slot:opt="{ row }">
        <el-tooltip
          class="item"
          effect="dark"
          :content="$l('INDEX.btn_tips_del') || '删除'"
          placement="top"
          v-if="allow('D')"
        >
          <i class="el-icon-delete tool-btn" @click="delRow(row)"></i>
        </el-tooltip>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import ExpandSampleTable from '../expand-sample-table'

export default {
  mixins: [TableAutoHeight],
  components: { ExpandSampleTable },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    loading: {
      default: false,
    },
    disabled: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        zoom: true,
        custom: true,
      },
      selectList: [],
      tableColumns: [
        {
          field: 'seq',
          width: 60,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          align: 'center',
          width: 70,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
          visible: !this.disabled,
        },
        {
          type: 'expand',
          width: 70,
          align: 'center',
          title: this.$l('INDEX.form_label_expand') || '展开',
          slots: {
            content: 'expandContent',
          },
        },
        {
          title: this.$l('table_label_locationNo') || '纸箱库位编号',
          field: 'locationNo',
          minWidth: 120,
          align: 'left',
          headerAlign: 'left',
          showHeaderOverflow: 'title',
          showOverflow: true,
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_locationName') || '纸箱库位名称',
          field: 'locationFullName',
          minWidth: 160,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_locType') || '库位类型',
          field: 'v_locType',
          minWidth: 90,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          sortable: true,
        },
        {
          title: this.$l('table_label_locSellType') || '库位售卖类型',
          field: 'locSellType',
          minWidth: 90,
          align: 'center',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          sortable: true,
        },
      ],
    }
  },
  methods: {
    delRow(row) {
      const { tableData = [] } = this.$refs.table.getTableData()
      for (let i = 0; i < tableData.length; i++) {
        if (tableData[i]._XID == row._XID) {
          this.$emit('delRow', i)
          return
        }
      }
    },
  },
}
</script>
